$(document).ready(function(){

  if ($('.s-gallery').length > 0){
    lightbox.option({
      'resizeDuration': 200,
      'wrapAround': true
    });
  }

});

